import React from "react";
import styles from "./A23TabBar.module.css";
import { CashGamesSort } from "@themed-components";
import { TourneyGamesSort } from "@themed-components";

const A23TabBar = ({
  tabs,
  activeTab,
  onTabChange,
  isTourney,
  removeFilter,
  setRemoveFilter,
  showSort = true,
}) => {
  return (
    <div className={styles.tabsContainer}>
      <div
        className={styles.tabsList}
        ref={(el) => {
          if (el) {
            const activeTabIndex = tabs.findIndex(
              (tab) => tab.gameType === activeTab.gameType
            );
            const activeTabElement = el.children[activeTabIndex];
            if (activeTabElement) {
              activeTabElement.scrollIntoView({
                behavior: "smooth",
                inline: "center",
              });
            }
          }
        }}
      >
        {tabs.map((tab, idx) => (
          <div
            onClick={() => onTabChange(tab)}
            key={idx}
            className={`${styles.tabButton} ${
              activeTab.gameType === tab.gameType ? styles.activeTab : ""
            }`}
          >
            {activeTab.gameType === tab.gameType && (
              <div className="w-full h-[26.67%] left-[50%] translate-x-[-50%] absolute top-[73.33%]  rounded-t-900 bg-linear-to-b from-transparent from-80% blur-sm to-gold-secondary" />
            )}
            {tab?.tabIcon && (
              <img
                src={tab?.tabIcon}
                alt="Tab Icon"
                className="object-cover"
                style={{ marginRight: 4, height: 16, width: 16 }}
              />
            )}
            {tab.name}
            <div className={styles.tabIndicator} />
          </div>
        ))}
      </div>
      {showSort &&
        (isTourney ? (
          <TourneyGamesSort
            removeFilter={removeFilter}
            setRemoveFilter={setRemoveFilter}
          />
        ) : (
          <CashGamesSort />
        ))}
    </div>
  );
};

export default A23TabBar;
